import type { QueryClient } from "@tanstack/react-query";

export const clauseChecklistQueryKeys = {
    adminLists: ["admin-clause-checklists"] as const,
    adminDetails: ["admin-clause-checklist-details"] as const,
    adminOrganizationDetails: [
        "admin-organization-details-clause-checklists",
    ] as const,
    organizationLists: ["organization-clause-checklists"] as const,
    tenantOrganizationLists: [
        "frontend-organization-clauseChecklists",
    ] as const,
    tenantDetails: ["frontend-clause-checklist"] as const,
    tenantClauseLibrary: ["frontend-organization-clause-library"] as const,
    tenantClauses: ["frontend-clause"] as const,
    relevanceStatus: ["clause-checklist-relevance-status"] as const,
};

export const invalidateClauseChecklistQueries = async (
    queryClient: QueryClient,
    options: { throwOnError?: boolean } = {}
) => {
    await Promise.all(
        Object.values(clauseChecklistQueryKeys).map((queryKey) =>
            queryClient.invalidateQueries({ queryKey }, options)
        )
    );
};
